import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { OrderIndFilter } from "../../../data/trading/orderIndicative/types"
import { LocalizationContext } from "../../../core/localization/Localization";
import { useOrderMarketOptionsTranslator } from "../../../data/trading/orders/hooks/useOrderMarketOptions";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useOrderIndStatusTypes } from "../../../data/initialData/hooks/useOrderIndStatus";
import { useOrderSideOptionsTranslator } from "../../../data/trading/orders/hooks/useOrderSideOptions";

export const OrderIndFilterChips: React.FunctionComponent<OrderIndFilterChipsProps> = ({
	filter,
	remnoveFilter,
}) => {
	const { getDateString, getString } = React.useContext(LocalizationContext);
	const marketTranslator = useOrderMarketOptionsTranslator();
	const sideTranslator = useOrderSideOptionsTranslator();

	const [statuses] = useOrderIndStatusTypes();

	const brokerName = filter.brokerid
		? `${filter.brokerid.firstName} ${filter.brokerid.lastName}`
		: undefined;

	const statusName =
		statuses?.find(s => s.ftValue === filter.status)?.ftDescr;

	const theme = useTheme();
	const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));

	return (
		<Grid container spacing={1}>
			{filter.side && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={sideTranslator(filter.side)}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("side")}
					/>
				</Grid>
			)}
			{filter.datefrom && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={`${getString("filterFrom")}: ${getDateString(new Date(filter.datefrom))}`}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("datefrom")}
					/>
				</Grid>
			)}
			{filter.dateto && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={`${getString("filterTo")}: ${getDateString(new Date(filter.dateto))}`}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("dateto")}
					/>
				</Grid>
			)}
			{filter.qtyfrom && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={`${getString("orderQtyFrom")}: ${filter.qtyfrom}`}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("qtyfrom")}
					/>
				</Grid>
			)}
			{filter.qtyto && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={`${getString("orderQtyTo")}: ${filter.qtyto}`}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("qtyto")}
					/>
				</Grid>
			)}
			{filter.product && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={filter.product.prodName}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("product")}
					/>
				</Grid>
			)}
			{filter.brokerid && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={brokerName || filter.brokerid}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("brokerid")}
					/>
				</Grid>
			)}
			{filter.status && !screenExtraSmall && (
				<Grid item>
					<Chip
						label={statusName || filter.status}
						color="secondary"
						variant="outlined"
						onDelete={() => remnoveFilter("status")}
					/>
				</Grid>
			)}
		</Grid>
	);
};

interface OrderIndFilterChipsProps {
	filter: OrderIndFilter;
	remnoveFilter: (type: keyof OrderIndFilter) => void;
}
